import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DROPDOWN_SLOT_DATA_ATTRIBUTE } from '../../constants/data-attribute.mjs';
import { dropdownSlot } from './slot.vanilla.mjs';

const DropdownSlot = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(dropdownSlot, classNameFromProps);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "dropdown",
        "data-part": "slot",
        className,
        ...getDropdownSlotDataAttribute(),
        ref: forwardedRef,
        ...props
      }
    );
  }
);
function getDropdownSlotDataAttribute() {
  return { [DROPDOWN_SLOT_DATA_ATTRIBUTE]: "" };
}

export { DropdownSlot };
//# sourceMappingURL=Slot.mjs.map
